<template>
  <div>
    <h4>Cartão de Crédito</h4>
    <div class="mt-2 mb-4">
      Um e-mail com os dados do pedido será enviado para <strong>{{ basket.email }}</strong>
    </div>

    <div class="mb-2">
      <vs-input class="w-full" label="Nome Completo" placeholder="Nome Completo" v-model="basket.name" />
    </div>

    <WhatsAppPhoneInput :basket="basket" />

    <div class="mb-2">
      <vs-input
        class="w-full"
        label="CPF/CNPJ do Titular do Cartão"
        placeholder="Somente números"
        v-model="basket.cpfcnpj"
      />
    </div>

    <stripe-checkout ref="checkoutRef" :pk="publishableKey" :session-id="sessionId">
      <template slot="checkout-button"></template>
    </stripe-checkout>

    <vs-button type="relief" class="w-full mt-6" @click="next()">Continuar</vs-button>
  </div>
</template>

<script>
import WhatsAppPhoneInput from '../WhatsAppPhoneInput.vue';
import { StripeCheckout } from 'vue-stripe-checkout';

export default {
  components: {
    WhatsAppPhoneInput,
    StripeCheckout
  },
  props: {
    checkoutWizard: {
      type: Object,
      required: true
    },
    paymentMethod: {
      type: String,
      required: true
    },
    basket: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      publishableKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
      sessionId: null
    };
  },
  methods: {
    next() {
      this.basket.processing = true;

      this.$api
        .post('/api/v1/checkout/order/create', {
          payment_method: this.paymentMethod,
          basket: this.basket,
          affiliate: localStorage.getItem('aff') || null
        })
        .then(response => {
          this.sessionId = response.data.sessionId;
          this.$refs.checkoutRef.redirectToCheckout();
        })
        .catch(error => {
          this.basket.processing = false;

          let errors = [];
          if (error.response && error.response.data.message) {
            errors.push(error.response.data.message);
          } else if (error.response) {
            for (const key in error.response.data) {
              if (Object.hasOwnProperty.call(error.response.data, key)) {
                errors.push(error.response.data[key]);
              }
            }
          }

          this.$vs.notify({
            time: 6000,
            text: errors.join('<br>'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
    }
  }
};
</script>
